export const counterpartyTypes = [
	'News Sites',
	'Betting Site',
	'Blog',
	'Car Repair/Dealership',
	'Clinic',
	'Clothing and Beauty Store',
	'Community Organization',
	'Consulting Companies',
	'Course/Skill Development Provider',
	'Delivery Service',
	'Embassy',
	'Financial Institution/Insurance/Pension',
	'Government/Municipalities',
	'Hotel/Rental Accommodation',
	'Legal Service/Law Firm',
	'Manufacturing',
	'Marketing Agencies',
	'Music and Book (incl. Other Printed Products) Store',
	'Non-Profit/Charity',
	'Other Business and Services',
	`Owner's Association`,
	'Politician/Political Party',
	'Real Estate',
	'Restaurant',
	'Show Venue/Culture Venue',
	'Sports Club/Sports League',
	'Store/Grocery Store',
	'Tourism Operator/Leisure Recommendation',
	'Undetermined',
]
